import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();
  const location = useLocation();

  const defaultItems: BreadcrumbItem[] = [
    { label: t('common.breadcrumb.home'), to: '/' },
  ];

  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    defaultItems.push({ label: t('nav.category'), to: '/category/all' });
    const categoryMap: Record<string, string> = {
      'latest-entry': '最新入口',
      'usage-tutorial': '使用教程',
      'safety-guide': '安全指南',
      'common-issues': '常见问题',
      'mobile-guide': '移动端指南',
      'tools-resources': '工具资源',
      'all': '全部文章',
    };
    defaultItems.push({ label: categoryMap[pathSegments[1]] || pathSegments[1] });
  } else if (pathSegments[0] === 'article' && pathSegments[1]) {
    defaultItems.push({ label: '文章详情' });
  } else if (pathSegments[0] === 'about') {
    defaultItems.push({ label: t('nav.about') });
  }

  const breadcrumbItems = items || defaultItems;

  return (
    <nav className="breadcrumb-nav py-3" aria-label="Breadcrumb">
      <ol>
        {breadcrumbItems.map((item, index) => (
          <li key={index}>
            {item.to && index < breadcrumbItems.length - 1 ? (
              <Link
                to={item.to}
                className="text-sm text-foreground-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-sm text-foreground-800 font-medium whitespace-nowrap">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}